import React, { useState, useEffect, useCallback } from 'react';

import { SearchInput, CloseButton, BaseButton, useT } from '@repo/common';
import { searchSkills } from '../../../../../api/career/career.api';
import SelectedSkills from './SelectedSkills';
import PopularSkills from './PopularSkills';
import SearchSkillsList from './SearchSkillsList';

const MobileAddSkillsBottomSheet = ({
  selected,
  onToggle,
  onRemove,
  onClose,
  $isMobile,
}) => {
  const t = useT();
  const [keyword, setKeyword] = useState('');
  const [results, setResults] = useState([]);
  const [showPopular, setShowPopular] = useState(true);

  const handleSearch = useCallback(async () => {
    if (!keyword.trim()) {
      setResults([]);
      return;
    }
    const data = await searchSkills(keyword);
    setResults(data.slice(0, 20));
  }, [keyword]);

  useEffect(() => {
    const timer = setTimeout(() => handleSearch(), 300);
    return () => clearTimeout(timer);
  }, [handleSearch, keyword]);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  const hasKeyword = keyword.trim().length > 0;

  return (
    <div className='fixed inset-0 z-[70] flex flex-col justify-end'>
      <div className='absolute inset-0 bg-surface-black40' onClick={onClose} />

      <div className='relative flex flex-col pt-4 px-6 pb-10 min-h-[530px] max-h-[790px] h-full rounded-t-[40px] bg-grayscale-gray00 animate-slideUp gap-6'>
        <div className='pb-3'>
          <CloseButton onClick={onClose} type='light' size='size-[32px]' />
        </div>
        <h2 className='typo-title1 text-text-primary'>{t('Add skills', '스킬 추가하기')}</h2>

        <div className='flex flex-col gap-4'>
          <SearchInput
            value={keyword}
            placeholder={t('Search and add skills', '스킬을 검색해 추가해 주세요')}
            activePlaceholder={t(
              'Search and add skills',
              '스킬을 검색해 추가해 주세요'
            )}
            onChange={(v) => setKeyword(v)}
            onEnter={handleSearch}
            autoFocus
          />

          <SelectedSkills selected={selected} onRemove={onRemove} />
        </div>
        {hasKeyword ? (
          <SearchSkillsList
            results={results}
            keyword={keyword}
            selected={selected}
            onToggle={onToggle}
            $isMobile={$isMobile}
          />
        ) : (
          showPopular && (
            <PopularSkills
              selected={selected}
              onSelect={onToggle}
              onClose={() => setShowPopular(false)}
              $isMobile={$isMobile}
            />
          )
        )}
      </div>

      <div className='relative shrink-0 p-4 bg-grayscale-gray00'>
        <BaseButton onClick={onClose} size='l' hideIcon width='100%'>
          {t('Done', '완료')}
        </BaseButton>
      </div>
    </div>
  );
};

export default MobileAddSkillsBottomSheet;
